/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebsectionphotos3Inputs */

const en_placewebsectionphotos3 = /** @type {(inputs: Placewebsectionphotos3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photos`)
};

const de_placewebsectionphotos3 = /** @type {(inputs: Placewebsectionphotos3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotos`)
};

/**
* | output |
* | --- |
* | "Photos" |
*
* @param {Placewebsectionphotos3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebsectionphotos3 = /** @type {((inputs?: Placewebsectionphotos3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebsectionphotos3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebsectionphotos3(inputs)
	return de_placewebsectionphotos3(inputs)
});
export { placewebsectionphotos3 as "placeWebSectionPhotos" }